// Direction logic of the phone energy-hub connectors, kept free of React so it can
// be unit tested.

export type FlowDirection = 'forward' | 'reverse' | 'idle';

// Below this the system is effectively idle; animating it would suggest activity
// that is not there.
export const ACTIVE_THRESHOLD_W = 10;

// Signed power -> travel direction. Positive runs down/right on screen (grid
// importing, battery charging, PV/loads), negative runs up/left (grid exporting,
// battery discharging) — the same sign convention the desktop diagram uses.
export function flowDirection(power: number): FlowDirection {
  if (!Number.isFinite(power) || Math.abs(power) < ACTIVE_THRESHOLD_W) {
    return 'idle';
  }
  return power > 0 ? 'forward' : 'reverse';
}

export function connectorClassName(
  orientation: 'vertical' | 'horizontal',
  power: number
): string {
  const direction = flowDirection(power);
  return [
    'hubFlow',
    orientation,
    direction !== 'idle' ? 'active' : '',
    direction === 'reverse' ? 'reverse' : ''
  ]
    .filter(Boolean)
    .join(' ');
}
